/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReportForDeviceResponseStbGroupHistoryElements,
    ReportForDeviceResponseStbGroupHistoryElementsFromJSON,
    ReportForDeviceResponseStbGroupHistoryElementsFromJSONTyped,
    ReportForDeviceResponseStbGroupHistoryElementsToJSON,
} from './ReportForDeviceResponseStbGroupHistoryElements';

/**
 * 
 * @export
 * @interface ReportForDeviceResponseStbGroupHistory
 */
export interface ReportForDeviceResponseStbGroupHistory {
    /**
     * 
     * @type {Array<ReportForDeviceResponseStbGroupHistoryElements>}
     * @memberof ReportForDeviceResponseStbGroupHistory
     */
    elements: Array<ReportForDeviceResponseStbGroupHistoryElements>;
    /**
     * 
     * @type {number}
     * @memberof ReportForDeviceResponseStbGroupHistory
     */
    totalElementCount: number | null;
}

export function ReportForDeviceResponseStbGroupHistoryFromJSON(json: any): ReportForDeviceResponseStbGroupHistory {
    return ReportForDeviceResponseStbGroupHistoryFromJSONTyped(json, false);
}

export function ReportForDeviceResponseStbGroupHistoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportForDeviceResponseStbGroupHistory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'elements': ((json['elements'] as Array<any>).map(ReportForDeviceResponseStbGroupHistoryElementsFromJSON)),
        'totalElementCount': json['totalElementCount'],
    };
}

export function ReportForDeviceResponseStbGroupHistoryToJSON(value?: ReportForDeviceResponseStbGroupHistory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'elements': ((value.elements as Array<any>).map(ReportForDeviceResponseStbGroupHistoryElementsToJSON)),
        'totalElementCount': value.totalElementCount,
    };
}

